import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import MyThemeProvider from '../../components/theme/MyThemeProvider';
import MyRouteProvider from '../../components/route/MyRouteProvider';
import appConfigPropTypes from '../../components/app/app-prop-types';
import MyIntlProvider from '../../components/intl/MyIntlProvider';
import MyStateProvider from '../../components/state/MyStateProvider';
import MyFirebaseProvider from '../../components/firebase/MyFirebaseProvider';
import MyFontProvider from '../../components/font/MyFontProvider';
import RafflesiaUserProvider from '../state/RafflesiaUserProvider';

const RafflesiaApp = ({ appConfig }) => {
  return (
    <HelmetProvider>
      <MyStateProvider
        stateAppStates={appConfig.stateAppStates}
        stateDefaultAppStates={appConfig.stateDefaultAppStates}
      >
        <MyFirebaseProvider
          firebaseConfig={appConfig.firebaseConfig}
          AuthenticationRepository={appConfig.AuthenticationRepository}
        >
          <RafflesiaUserProvider>
            <MyIntlProvider
              intlSupportedLocales={appConfig.intlSupportedLocales}
              intlDefaultLocale={appConfig.intlDefaultLocale}
              intlMessageLocales={appConfig.intlMessageLocales}
              intlMessageSeedLocales={appConfig.intlMessageSeedLocales}
              intlExtraMessageLocales={appConfig.intlExtraMessageLocales}
            >
              <MyFontProvider
                fontDefaultFont={appConfig.fontDefaultFont}
                fontSupportedFonts={appConfig.fontSupportedFonts}
                fontDefaultFontSize={appConfig.fontDefaultFontSize}
                fontSupportedFontSizes={appConfig.fontSupportedFontSizes}
              >
                <MyThemeProvider
                  themeDefaultTheme={appConfig.themeDefaultTheme}
                  themeSupportedThemes={appConfig.themeSupportedThemes}
                  themeThemes={appConfig.themeThemes}
                >
                  <MyRouteProvider
                    appRoutes={appConfig.appRoutes}
                    notFoundPage={appConfig.notFoundPage}
                    loadingPage={appConfig.loadingPage}
                    AuthenticationRepository={appConfig.AuthenticationRepository}
                    applicationName={appConfig.applicationName}
                    commonComponentProps={appConfig.commonComponentProps}
                    icons={appConfig.icons}
                    initialRouteEntries={appConfig.initialRouteEntries}
                  />
                </MyThemeProvider>
              </MyFontProvider>
            </MyIntlProvider>
          </RafflesiaUserProvider>
        </MyFirebaseProvider>
      </MyStateProvider>
    </HelmetProvider>
  );
};

RafflesiaApp.propTypes = {
  appConfig: appConfigPropTypes.isRequired,
};

export default RafflesiaApp;
